import {
    ORDER_STATUS_REFUNDED,
    ORDER_STATUS_COMPLETED,
    ORDER_STATUS_NOT_COMPLETED,
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";

export const useStatusValuesOrder = () => {
    const {t} = useTranslation(['mobilityvoucher']);
    const theme = useTheme();
    const getStatusColorOrder = (status: string) => {
        switch (status) {
            case ORDER_STATUS_REFUNDED: return theme.palette.warning.transparent;
            case ORDER_STATUS_COMPLETED: return theme.palette.success.transparent;
            case ORDER_STATUS_NOT_COMPLETED: return theme.palette.error.transparent;
        }
    };

    const getStatusLabelOrder = (status: string) => {
        switch (status) {
            case ORDER_STATUS_REFUNDED: return t('mobilityvoucher:status.refunded');
            case ORDER_STATUS_COMPLETED: return t('mobilityvoucher:status.completed');
            case ORDER_STATUS_NOT_COMPLETED: return t('mobilityvoucher:status.notCompleted');
        }
    };

    return {
        getStatusColorOrder,
        getStatusLabelOrder
    }
}